import { AxiosInstance } from "axios"
import { ImageFile } from "./imagesTypes"
import { ServiceResponse } from "../../../core/api/apiTypes"

type ImageParam = Readonly<{
    uid: number
}>
type ImageResponse = {
    image: ImageFile
}

export async function fetchImage(
    { uid }: ImageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ImageResponse> {
    const url = `/images/byUid/${uid}`

    const response = await axios.get(url, { signal })

    return response.data
}

type UploadImageParams = {
    image: File
    typeOfEntity: string
}

export async function uploadImage(
    params: UploadImageParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ImageResponse> {
    const { image, typeOfEntity } = params
    const formData = new FormData()
    formData.append("file", image)
    formData.append("type", typeOfEntity)

    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        signal,
    }

    const { data } = await axios.post("/images", formData, config)

    return data
}

export async function deleteImage(
    { uid }: ImageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/images/byUID/${uid}`, {
        signal,
    })
    return data
}
